import React from 'react';
import {
  Button,
  Checkbox,
  Flex,
  Text,
  useColorMode,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  Icon,
  Grid,
} from '@chakra-ui/react';
import { CaretDown, PlusCircle, XCircle } from '@phosphor-icons/react';
import { Formik } from 'formik';

interface FilterSelectPillProps {
  clear: () => void;
  setValues: (values: string[]) => void;
  options: Array<{
    value: string;
    label: string;
  }>;
  initialValues: string[];
  label: string;
  isDisabled?: boolean;
  // colorScheme?: string;
}

export const FilterSelectPill: React.FC<FilterSelectPillProps> = ({ isDisabled, clear, initialValues, options = [], label, setValues }) => {
  const { colorMode } = useColorMode();

  const getSelectedText = () => {
    const selectedTextArray: string[] = [];
    initialValues?.forEach((value) => {
      const foundValue = options.find((option) => option.value === value);
      if (foundValue) selectedTextArray.push(foundValue.label);
    });

    if (selectedTextArray.length === 0) return false;
    if (selectedTextArray.length > 3) {
      return 'Mehrere';
    }

    let returnText = '';
    selectedTextArray.forEach((text, index) => {
      returnText = returnText + text;
      if (index + 1 !== selectedTextArray.length) returnText = returnText + ', ';
    });
    return returnText;
  };
  const selectedText = getSelectedText();

  return (
    <Popover placement="bottom-start">
      {/* @ts-ignore */}
      <PopoverTrigger>
        <Flex
          border={selectedText ? '1px solid' : '1px dashed'}
          borderColor="gray.300"
          color={colorMode === 'light' ? 'gray.500' : 'gray.400'}
          alignItems="center"
          gap="1"
          rounded="full"
          fontSize="xs"
          fontWeight="semibold"
          px="1.5"
          py="0.5"
          cursor="pointer"
          transition="all"
          pointerEvents={isDisabled ? 'none' : 'all'}
          opacity={isDisabled ? '0.2' : '1'}
          _hover={{
            bg: colorMode === 'light' ? 'gray.100' : 'gray.700',
            color: colorMode === 'light' ? 'gray.600' : 'gray.200',
          }}
        >
          {selectedText ? (
            <Icon
              as={XCircle}
              h="3"
              w="3"
              onClick={(event) => {
                event.stopPropagation();
                clear();
              }}
            />
          ) : (
            <Icon
              as={PlusCircle}
              h="3"
              w="3"
              _hover={{
                color: 'gray.900',
              }}
            />
          )}
          <Text as="span">{label}</Text>
          {selectedText ? (
            <>
              <Text as="span" fontSize="10px">{` | `}</Text>
              <Text as="span" color="blue.500">
                {selectedText}
              </Text>
              <Icon
                as={CaretDown}
                h="4"
                w="4"
                _hover={{
                  color: 'gray.900',
                }}
              />
            </>
          ) : (
            ''
          )}
        </Flex>
      </PopoverTrigger>

      <PopoverContent className="bg-white dark:bg-gray-900 shadow-2xl border border-gray-200 dark:border-gray-800 rounded p-3" w="250px">
        <>
          <PopoverArrow />
          <Formik
            initialValues={{
              values: initialValues,
            }}
            enableReinitialize
            onSubmit={({ values }) => {
              setValues(values);
              //   close();
            }}
          >
            {({ values, setFieldValue, handleSubmit }) => {
              return (
                <Grid p="2">
                  {options.map(({ label, value }) => {
                    const selected: boolean = (values.values as any).includes(value);

                    return (
                      <Checkbox
                        key={value}
                        isChecked={selected}
                        onChange={(e) => {
                          const assigneesWithoutUser = [...values.values].filter((filterValue) => filterValue !== value);

                          setFieldValue('values', selected ? assigneesWithoutUser : [...values.values, value]);
                        }}
                        mb="0.5"
                      >
                        <Text as="span" fontSize="sm">
                          {label}
                        </Text>
                      </Checkbox>
                    );
                  })}

                  <Button colorScheme="teal" size="sm" fontWeight="medium" w="full" mt="4" onClick={() => handleSubmit()}>
                    Speichern
                  </Button>
                </Grid>
              );
            }}
          </Formik>
        </>
      </PopoverContent>
    </Popover>
  );
};
